import * as R from 'ramda'
import firebase from './firebase'
import country from 'country-code-lookup'

export default {
  rejectEmpnil (obj) {
    return R.reject(isEmpnil, obj)
  },
  nullifyEmpnil (obj) {
    return R.map((v) => (isEmpnil(v) ? null : v))(obj)
  },
  strToArr (delimiter, str) {
    return R.pipe(R.split(delimiter), R.map(R.trim), R.reject(R.isEmpty))(str)
  },
  existArr: R.both(R.complement(R.isEmpty), R.complement(R.isNil)),
  isEmpnil,
  ts (src, isNew = true) {
    const TS = firebase.client.database.ServerValue.TIMESTAMP
    const tsObj = isNew ? { createdAt: TS, updatedAt: TS } : { updatedAt: TS }
    return R.merge(src, tsObj)
  },
  isFileOrBlob: (o) => o instanceof window.Blob || o instanceof window.File,
  isInt: (n) => n % 1 === 0,
  waitForInitial (ref, delay = 0) {
    let received = false

    return new Promise((resolve, reject) => {
      ref.on('value', function receive (snap) {
        if (!snap.exists() || snap.val() !== 2) return
        received = true

        snap.ref.off('value', receive)
        snap.ref.remove()

        if (delay) {
          setTimeout(() => {
            resolve(snap.val())
          }, delay)
        } else {
          resolve(snap.val())
        }
      })

      setTimeout(() => {
        if (!received) {
          const err = new Error('timeout')
          err.code = 'app/timeout'
          reject(err)
        }
      }, 1000 * 30)
    })
  },
  wait (ms) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve()
      }, ms)
    })
  },
  uuid () {
    return `${Date.now()}-${Math.floor(Math.random() * 1000)}`
  },
  isNil (x) {
    return x == null
  }
}

function getLanguage () {
  const lang =
    navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.userLanguage ||
        navigator.language ||
        navigator.browserLanguage ||
        'en'

  // force language to only korean or en
  return lang.substr(0, 2) === 'ko' ? 'ko' : 'en'
}

const getLocale = () => localStorage.getItem('locale') || getLanguage()

const prependProcotol = (url) => {
  if (!R.isEmpty(url) && !/^https?:\/\//i.test(url)) {
    url = `http://${url}`
  }
  return url
}

const newlineToBr = (str = '') => str.replace(/(?:\r\n|\r|\n)/g, '<br>')

export {
  branchPlatform,
  noop,
  getLanguage,
  getLocale,
  promisify,
  getRegion,
  currency,
  prependProcotol,
  newlineToBr
}

function isEmpnil (val) {
  return R.either(R.isEmpty, R.isNil)(val)
}

function branchPlatform (fns) {
  fns.native = fns.native || noop
  fns.browser = fns.browser || noop

  const platform = device.platform.toLowerCase()

  if (platform === 'ios' || platform === 'android') {
    return fns.native()
  } else {
    return fns.browser()
  }
}

function noop () {}

function promisify (fn, startIdx) {
  return (...args) => {
    startIdx = R.isNil(startIdx) ? args.length : startIdx
    return new Promise((resolve, reject) => {
      fn(...R.insertAll(startIdx, [resolve, reject], args))
    })
  }
}

function getRegion () {
  const iso = getLanguage() === 'ko' ? 'kr' : 'us'
  const c = country.byIso(iso)
  const continent = c ? c.continent : 'Americas'

  return {
    Asia: 'asia',
    Oceania: 'asia',
    Americas: 'us',
    Antarctica: 'us',
    // the continents below is europe originally
    Europe: 'us',
    Africa: 'us',
    'Atlantic Ocean': 'us',
    'Indian Ocean': 'us'
  }[continent]
}

function currency (code, num) {
  return new Intl.NumberFormat(getLanguage(), {
    style: 'currency',
    maximumFractionDigits: 2,
    currency: code
  }).format(num)
}
